import { render, staticRenderFns } from "./SettingsDocs.vue?vue&type=template&id=7aedaeca&scoped=true&"
import script from "./SettingsDocs.vue?vue&type=script&lang=js&"
export * from "./SettingsDocs.vue?vue&type=script&lang=js&"
import style0 from "./SettingsDocs.vue?vue&type=style&index=0&id=7aedaeca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aedaeca",
  null
  
)

export default component.exports